import styled from 'styled-components';
import { ThemeType } from '../../../types/Theme';

const TabelaEdicaoContainer = styled.div<{ theme: ThemeType }>`
    width: 100%;
    color: ${({ theme }) => theme.colors.tertiary};
    padding: 6rem 10rem 4rem 10rem;
    .filtros{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;
        padding: 2rem 0;
        .filtros-container{
            display: flex;
            gap: 2rem;
            align-items: center;
            justify-content: center;
        }
        .select-filtro-container{
            width: 50rem;
        }
        .toggle-cabecalho{
            display: flex;
            align-items: center;
            gap: 1rem;
            padding-top: 3.5rem;
            color: ${({ theme }) => theme.colors.tertiary};
        }
    }
    .mensagem {
        margin: 10rem 0;
        width: 100%;
        .texto-titulo {
            text-align: center;
            color: ${(props) => props.theme.colors.tertiary};
        }

        .texto-subtitulo {
            text-align: center;
            color: ${(props) => props.theme.colors.tertiary};
        }
    }
    .table-wrapper{
        overflow: auto;
        position: relative;
    }
    table{
        width: 100%;
        position: relative;
        thead{
            position: sticky;
            top: 0;
            z-index: 2;
            background-color: ${({ theme }) => theme.colors.background2};
            tr{
                th{
                    padding: 1rem;
                    .select-coluna{
                        width: 30rem;
                        .select{
                            background-color: transparent;
                            padding: 0;
                            border-color: transparent !important;
                            .placeholder{
                                color: ${({ theme }) => theme.colors.brandDanger};
                            }
                        }
                    }
                    .invalid{
                        .select{
                            .selecionado{
                                color: ${({ theme }) => theme.colors.brandDanger};
                            }
                        }
                    }
                }
            }
        }
        tbody{
            tr{
                td{
                    text-align: left;
                    padding: 1rem;
                    cursor: pointer;
                    .table-data{
                        width: 30rem;
                        position: relative;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        .descricao{
                            width: 100%;
                            height: 3rem;
                        }
                    }

                    &.col-nome .table-data{
                        width: 45rem;
                    }

                    .invalid{
                        color: ${({ theme }) => theme.colors.brandDanger};
                        .placeholder{
                            color: ${({ theme }) => theme.colors.brandDanger};
                        }
                        &[data-reason]{
                            overflow: visible;
                            &::after{
                                content: attr(data-reason);
                                font-size: 12px;
                                pointer-events: none;
                                opacity: 0;
                                transition: opacity 0.3s ease-in-out;
                                position: absolute;
                                text-align: left;
                                z-index: 10;
                                bottom: calc(100% + 0.5rem);
                                left: 0;
                                color: ${(props) => props.theme.colors.tertiary};
                                background-color: ${(props) => props.theme.colors.elements};
                                padding: 1rem 1.5rem;
                                white-space: normal;
                                width: max-content;
                                max-width: 40rem;
                                border-radius: 1rem;
                                filter: drop-shadow(0px 2px 2px #626262);
                                @media (max-width: 1024px) {
                                    font-size: 10px;
                                }
                            }
                            &:hover::after{
                                opacity: 1;
                            }
                        }
                    }
                    .placeholder{
                        color: ${({ theme }) => theme.colors.placeholder};
                    }

                }
                .trash-td{
                    position: sticky;
                    right: 0;
                    .trash-container{
                        display: flex;
                        width: 10rem;
                        align-items: center;
                        justify-content: center;
                        border-radius: 20px;
                        background-color: ${({ theme }) => theme.colors.elements};
                        padding: 1rem;
                        transition: 0.2s ease-in-out;
                        .trash{
                            width: 3rem;
                            fill: ${({ theme }) => theme.colors.tertiary};  
                        }
                        &:hover{
                            transform: scale(1.1);
                        }
                    }
                }
                
                .disabled{
                    cursor: not-allowed !important;
                    opacity: 0.4 !important;
                }
                > :first-child {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }

                > :last-child {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                }
            }
            > :nth-child(2n) {
                background-color: ${({ theme }) => theme.colors.white};
            }

            > :nth-child(2n + 1) {
                background-color: ${({ theme }) => theme.colors.background2};
            }

            
        }
    }
    .tfoot{
        cursor: pointer;
        margin: 1rem 0;
        transition: background-color 0.2s ease-in-out;
        border-radius: 20px;
        width: 100%;
        height: 6rem;
        position: sticky;
        left: 0;
        .tfoot-adicionar{
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2rem;
            .plus{
                width: 3rem;
                height: 3rem;
                fill: ${({ theme }) => theme.colors.tertiary};
            }
        }
        &:hover{
            background-color: ${({ theme }) => theme.colors.white};
        }
    }
    .footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;
        .ajustar{
            width: 30rem;
        }
    }
    /* nesta tela o footer fixo é alto demais e rouba altura da tabela em telas baixas (ex.: 1366x768);
       reduz o espaço morto inferior só aqui (desktop), recuperando área útil pra tabela + scroll horizontal */
    @media (min-width: 1024px) {
        .container-footer-paginas{
            padding-bottom: 2rem;
            .children-footer{
                padding-top: 1.5rem;
            }
        }
    }
    @media (max-width: 1024px) {
        padding: 3rem 5rem 4rem 5rem;
        .footer{
            justify-content: center;
            flex-direction: column;
            align-items: center;
            .ajustar{
                width: 100%;
            }
        }
    }
`;

export {
  TabelaEdicaoContainer
};
